// popup.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PopupService {
  private popupShownKey = 'popupShown';

  constructor() {}

  hasPopupBeenShownToday(): boolean {
    const lastShownDate = localStorage.getItem(this.popupShownKey);

    if (!lastShownDate) {
      return false; // Popup has not been shown before
    }

    const today = new Date().toDateString();
    return lastShownDate === today;
  }

  markPopupAsShown(): void {
    const today = new Date().toDateString();
    localStorage.setItem(this.popupShownKey, today);
  }
}
